import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {AtomoTime} from "../../../../../components/AtomoTime";
import {ButtonSmall} from "../../../../../components/ButtonSmall";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const YoungOnboardingPhone = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_welcome-young-mobile${currentParams}`);
  };

  return (
      <div className="young-onboarding-phone">
        <div className="young-onboarding-3">
          <div className="overlap-3">
            <div className="overlap-4">
              <div className="frame-19">
                <div className="ellipse-5" />
              </div>

              <div className="frame-20">
                <div className="molecula-stepper-2">
                  <div className="content-6">
                    <div className="numb-4">
                      <div className="text-wrapper-16">1</div>
                    </div>

                    <div className="line-4" />
                  </div>

                  <div className="div-4">
                    <div className="div-4">
                      <div className="numb-5">
                        <div className="text-wrapper-17">2</div>
                      </div>

                      <div className="line-4" />
                    </div>
                  </div>

                  <div className="div-4">
                    <div className="div-4">
                      <div className="numb-5">
                        <div className="text-wrapper-17">3</div>
                      </div>

                      <div className="line-4" />
                    </div>
                  </div>

                  <div className="div-4">
                    <div className="div-4">
                      <div className="numb-6">
                        <div className="text-wrapper-18">4</div>
                      </div>

                      <div className="line-5" />
                    </div>
                  </div>

                  <div className="div-4">
                    <div className="div-4">
                      <div className="numb-7">
                        <div className="text-wrapper-19">5</div>
                      </div>

                      <div className="line-6" />
                    </div>
                  </div>

                  <div className="atomo-step-final-no-2">
                    <div className="content-7">
                      <div className="numb-7">
                        <div className="text-wrapper-19">6</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="group-6">
                  <div className="signature-cinemawide-wrapper">
                    <img
                        alt="Validate Phone"
                        src="/img/phone-adultos.png"
                        style={{ marginLeft: -10, marginTop: -20, objectFit:'contain',width:150 }}
                    />
                  </div>
                </div>

                {/* <div className="frame-21">
                <div className="subtitle-7">What’s your Email address?</div>
              </div> */}

                <div className="element-4">
                  <p className="subtitle-8">
                  <span className="text-wrapper-20">
                    A validation code has been sent to
                  </span>
                    <br></br>
                    <span className="text-wrapper-21">+54 9 1122 6476</span>
                  </p>

                  <div className="numbs">
                    <div className="element-wrapper">
                      <div className="element-5">2</div>
                    </div>

                    <div className="element-wrapper">
                      <div className="element-5">2</div>
                    </div>

                    <div className="element-wrapper">
                      <div className="element-5">2</div>
                    </div>

                    <div className="element-wrapper">
                      <div className="element-5">2</div>
                    </div>
                  </div>

                  <AtomoTime
                      className="atomo-time-instance"
                      rectangleClassName="atomo-time-3"
                      subtitleCopyClassName="atomo-time-4"
                      subtitleCopyClassNameOverride="atomo-time-4"
                      timelineClassName="atomo-time-2"
                  />
                  <ButtonSmall
                      className="button-small-instance"
                      estado="inactivo"
                      iconLeft={false}
                      iconRigth={false}
                      textClassName="button-small-2"
                      texto="Resend code"
                      tipo="link"
                  />
                  <div className="action-buttons-3" onClick={handleButtonClick}>
                    <div className="frame-22 highlighted-button">
                      <div className="text-wrapper-22">Validate</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="frame-23">
              <div className="status-bar-2"></div>

              <div className="panel-panel-primary-3">
                <div className="title-3">Register Mobile number</div>

                <img
                    className="icons-arrow-back-3"
                    alt="Icons arrow back"
                    src="/img/icons-arrow-back-1.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
